import React from 'react';
import RadioButton from 'components/DesignSystem/RadioButton';
import useNewStudyForm from 'utils/hooks/flux/personalized/useNewStudyForm';

function PrevivazModelRadioButton(label) {
  const { previvazModel, setPrevivazModel } = useNewStudyForm();

  return (
    <RadioButton
      name="previvaz"
      label={label}
      key={label}
      checked={previvazModel === label}
      onChange={() => {
        setPrevivazModel(label);
      }}
    />
  );
}

export default function PrevivazModel() {
  const labels = [
    'Produzir todas as revisões',
    'Produzir somente RV0/RVF/RVXmax',
    'Produzir RVF/RVXmax',
  ];
  return (
    <div>
      {labels.map((label) => PrevivazModelRadioButton(label))}
    </div>
  );
}
